<template>
  <Paginate
    :container-class="'pagination'"
    :page-count="option.limit"
    :force-page="option.force"
    :click-handler="onClick"
    :no-li-surround="true"
    :first-last-button="true"
    :page-range="10"
    :prev-text="'&#8249;'"
    :next-text="'&#8250;'"
    :first-button-text="'&#171;'"
    :last-button-text="'&#187;'">
  </Paginate>
</template>

<script>
import Paginate from 'vuejs-paginate'

export default {
  name: 'Pagination',
  components: {
    Paginate
  },
  props: [
    'option'
  ],
  data () {
    return {
    }
  },
  methods: {
    onClick (current) {
      this.$emit('onPagingClick', current)
    }
  }
}
</script>
